import { ReactNode } from "react";
import styles from "@/pages/index.module.css";

export const Colors = [
  "#2E2E2E",
  "#A8764A",
  "#F06969",
  "#FFAA7D",
  "#FFE085",
  "#89C28D",
  "#4C95CF",
  "#C482C4",
];

const ColorDisplayData: Record<
  string,
  { shadow: string; highlightOpacity: number; label: string }
> = {
  "#2E2E2E": { shadow: "#1B1B1B", highlightOpacity: 0.25, label: "Black" },
  "#A8764A": { shadow: "#9B6D45", highlightOpacity: 0.25, label: "Brown" },
  "#F06969": { shadow: "#E56363", highlightOpacity: 0.25, label: "Red" },
  "#FFAA7D": { shadow: "#F5A174", highlightOpacity: 0.35, label: "Orange" },
  "#FFE085": { shadow: "#F6D779", highlightOpacity: 0.6, label: "Yellow" },
  "#89C28D": { shadow: "#82BB86", highlightOpacity: 0.35, label: "Green" },
  "#4C95CF": { shadow: "#478AC1", highlightOpacity: 0.25, label: "Blue" },
  "#C482C4": { shadow: "#BA7BBA", highlightOpacity: 0.25, label: "Purple" },
};

type ColorOptionProps = {
  hexColor: string;
  onSelect: (color: string) => void;
  isSelected: boolean;
};

function ColorOption({ hexColor, onSelect, isSelected }: ColorOptionProps): ReactNode {
  const { shadow, highlightOpacity, label } = ColorDisplayData[hexColor];

  return (
    <button
      className={`${styles.colorOption} ${isSelected ? styles.selectedColorOption : ""}`}
      style={{ backgroundColor: shadow }}
      data-color={hexColor}
      onClick={() => {
        onSelect(hexColor);
      }}
      aria-label={`${label} color option`}
    >
      <div
        className={`${styles.colorOptionInner} ${isSelected ? styles.selectedColorOptionInner : ""}`}
        style={{
          backgroundColor: hexColor,
          borderColor: `rgb(255, 255, 255, ${highlightOpacity})`,
        }}
      />
    </button>
  );
}

type ColorPickerProps = {
  onSelect: (color: string) => void;
  selectedColor: string;
};

export function ColorPicker({ onSelect, selectedColor }: ColorPickerProps): ReactNode {
  return (
    <div className={styles.colorPicker}>
      {Colors.map((color) => (
        <ColorOption
          key={color}
          isSelected={selectedColor === color}
          hexColor={color}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
